import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate
} from "react-router-dom";
import Header from './component/Header';
import Footer from './component/Footer';
import Home from './pages/home';
import UploadDocument from './pages/UploadDocuments';
import MortgageForm from './pages/form';
import FinalReport from './pages/final-report';
import Dashboard from './pages/dashboard';
import Staff from './pages/staff-login';
import StaffDashboard from './pages/staff-dashboard';
import ManageStaff from './pages/staff';
import FormDetailView from './pages/form-detail-view';

const Layout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);

const AuthGuard = ({ element }) => {
  const userToken = localStorage.getItem('userToken');
  return userToken ? element : <Navigate to="/" replace />;
};

const routers = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <App />
      },
      {
        path: 'mortgage_form',
        element: <AuthGuard element={<Dashboard />} />
      },
      {
        path: 'mortgage_form/initial-requirement',
        element: <AuthGuard element={<Home />} />
      },
      {
        path: 'mortgage_form/:step',
        element: <AuthGuard element={<MortgageForm />} />
      },
      {
        path: 'docs',
        element: <AuthGuard element={<UploadDocument />} />
      },
      {
        path: 'form_preview',
        element: <AuthGuard element={<FinalReport />} />
      },
      {
        path: 'mortgage/mga-staff-portal',
        element: <Staff />
      },
      {
        path: 'mga-staff-portal/dashboard',
        element: <AuthGuard element={<StaffDashboard />} />
      },
      {
        path: 'mga-staff-portal/manage-staff',
        element: <AuthGuard element={<ManageStaff />} />
      },
      {
        path: 'mga-staff-portal/form-details-view',
        element: <AuthGuard element={<FormDetailView />} />
      },
      {
        path: "*",
        element: <Navigate to='mortgage_form' replace />,
      },
    ]
  }
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={routers} />
  </React.StrictMode>
);

reportWebVitals();